// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import {guess_os_and_version} from '../client_hints_global';
import {guess_browser} from 'zuser_agent';
import hopt from 'hola_opt';
import {use_browser} from '../lib/use_browser';
import * as ui_links from './ui_install_links';
// @ts-ignore
import {GDL} from '../site_load.js';
// @ts-ignore
import cookie from 'cookie';

const tv_links = {
    tvos: ui_links.appletv_href,
    fireos: ui_links.firetv_href,
    webos: '/download/lg',
};

const console_links = {
    xbox: '/plus_setup?platform=console&type=xbox_one',
    ps: '/plus_setup?platform=console&type=ps4',
};

export const mobile_links = {
    ios: GDL.ios.url,
    huawei: ui_links.huawei_href,
    // XXX dmitriikup: URG request from noav to remove all Samsung
    // mentions from www
    // samsung: ui_links.samsung_href,
    all: '/download',
    mobile: '/download?cat=mobile',
};

const DEFAULT_AFTER_DOWNLOAD_PAGE = '/after_download?s=install';
const DEFAULT_CTA_TITLE = `Get Hola - it's free`;

interface i_use_install_info_props {
    host?: string;
    download_browser?: boolean;
    download_vpn?: boolean;
    user_country?: string;
    app_fixed?: string;
    gameboost_href?: string;
}
export const use_install_info = (props: i_use_install_info_props)=>{
    const {host, download_browser, download_vpn, user_country,
        app_fixed, gameboost_href} = props;
    const b = guess_browser();
    const browser = use_browser();
    const sys = guess_os_and_version();
    const os = sys.os;
    const again_promo_ext = download_browser || download_vpn ? false :
        (hopt.www_hola.propose_browser_from_hp || [])
        .indexOf((user_country||'').toUpperCase())==-1 &&
        ['opera', 'chrome', 'edge'].indexOf(browser)>-1;
    let cta = DEFAULT_CTA_TITLE;
    if (app_fixed=='gameboost')
        return {app: 'gameboost', os, href: gameboost_href, cta};
    if (!app_fixed && os=='ios')
    {
        cta = 'Get Hola for iOS!';
        return {app: 'mobile', os, browser, href: mobile_links.ios, cta};
    }
    if (app_fixed=='tv'
        || !app_fixed && ['fireos', 'tvos', 'webos'].indexOf(os)>=0)
    {
        return {app: 'tv', os, href: tv_links[os], cta};
    }
    if (app_fixed=='console'
        || !app_fixed && ['xbox', 'ps'].indexOf(sys.os)>=0)
    {
        return {app: 'console', os, href: console_links[os], cta};
    }
    if (!app_fixed && os=='android')
        cta = 'Get Hola for Android!';
    if (!app_fixed && b.huawei)
    {
        return {app: 'mobile', os, browser: 'huawei',
            href: mobile_links.huawei, cta};
    }
    // XXX dmitriikup: URG request from noav to remove all Samsung
    // mentions from www
    // if (!app_fixed && b.samsung)
    // {
    //     return {app: 'mobile', os, browser: 'samsung',
    //         href: mobile_links.samsung, cta};
    // }
    if (!app_fixed && hopt.www_hola.link_download_apk && os=='android')
    {
        const href = hopt.www_hola.link_download_apk
            + '?ref=www_hola_install_btn';
        return {app: 'mobile', os, href, cta};
    }
    if (!app_fixed && hopt.www_hola.open_downloads_from_hp && os=='android')
    {
        const href = hopt.www_hola.open_downloads_from_hp;
        return {app: 'mobile', os, href, cta};
    }
    if (app_fixed=='mobile' || !app_fixed && sys.mobile)
        return {app: 'mobile', href: mobile_links.mobile, cta};
    if (app_fixed=='ext' || !app_fixed && b.hola_browser && !download_vpn)
    {
        cta = `Add to Hola Browser`;
        return {app: 'ext', os, browser, cta};
    }
    if ((app_fixed=='vpn' || !app_fixed) && !download_browser && os=='windows'
        && ['/', '/products/desktop'].includes(location.pathname)
        && ['10.0', '11.0', '7', '8'].includes(sys.version))
    {
        const href = DEFAULT_AFTER_DOWNLOAD_PAGE;
        const before_redirect = ()=>{
            try {
                // @ts-ignore
                document.getElementsByClassName('hola_footer')[0]
                // @ts-ignore
                    .style.display = 'none';
            } catch {}
        };
        return {app: 'vpn', os, href, cta, before_redirect};
    }
    if (app_fixed=='vpn' && os=='macos'
        || !app_fixed && os=='macos' && (browser=='safari'
        || browser=='chrome'))
    {
        return {app: 'vpn', os, href: DEFAULT_AFTER_DOWNLOAD_PAGE, cta};
    }
    if (!app_fixed
        && ((hopt.www_hola.promo_enabled_browsers || []).indexOf(b)>-1 &&
        os=='linux' || again_promo_ext))
    {
        const title = b.hola_browser && !download_vpn ? 'Hola Browser' :
            browser.toUpperCase()[0] + browser.substring(1);
        cta = `Add to ${title} - it's free`;
        return {app: 'ext', os, browser, cta};
    }
    const is_holafreevpn = host=='holafreevpn.com';
    let c_vpn_c = cookie.get('c_vpn') && cookie.get('c_vpn')!=='organic' ?
        cookie.get('c_vpn') : '';
    const c_vpn = c_vpn_c;
    const c_browser = cookie.get('c_browser');
    if (app_fixed!='vpn' && c_browser &&
        !is_holafreevpn && !(c_vpn && !c_browser)
        || download_browser || app_fixed=='browser')
    {
        return {app: 'browser', os, href: DEFAULT_AFTER_DOWNLOAD_PAGE, cta};
    }
    return {app: 'vpn', href: DEFAULT_AFTER_DOWNLOAD_PAGE, cta};
};
